import {fontName, THEME} from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
import {Icon} from '@wandb/weave/components/Icon';
import styled from 'styled-components';

export const WysiwygNotice = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${fontName};
  border: 1px solid ${THEME.border};
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 32px;
`;

export const WysiwygNoticeSuccess = styled.div`
  display: flex;
  align-items: center;
`;

export const WysiwygNoticeSuccessIcon = styled(Icon)`
  flex-shrink: 0;
  font-size: 24px;
  margin-right: 8px;
`;

export const WysiwygNoticeLink = styled(TargetBlank)`
  color: ${THEME.textTertiary};
  &:hover {
    color: ${THEME.textPrimary};
  }
  && {
    text-decoration: underline;
  }
`;

export const WysiwygNoticeActions = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin-left: 32px;
`;

export const WysiwygConvert = styled.div`
  color: ${THEME.textLink};
  &:hover {
    color: ${THEME.accentHover};
  }
  cursor: pointer;
`;

export const WysiwygRevert = styled.div`
  color: ${THEME.statusErrorText};
  &:hover {
    color: ${THEME.statusErrorText};
  }
  cursor: pointer;
`;

export const WysiwygDismiss = styled.div`
  color: ${THEME.textTertiary};
  &:hover {
    color: ${THEME.textPrimary};
  }
  cursor: pointer;
  margin-left: 24px;
`;
